import React from "react";
import "./Loader.css"; // Import a CSS file for styling

const LoginLoader = () => {
  return (
    <div className="loader-login-container">
      <div className="loader"></div>
    </div>
  );
};

export default LoginLoader;
